export default __webpack_public_path__ + "static/media/f-logo.66ce5d83.svg";